import React from "react";
import { ConsultLink, StatusIcon, StatusItem, StatusList } from "./styles";
import { BsCheckCircleFill, BsClock } from "react-icons/bs";
import { ChargeIdStatusType } from "views/Pix/providers/dto/create-checkout.dto";
import { CircleAlert } from "lucide-react";

type StatusDictRecordKey = ChargeIdStatusType.WAITING_CHARGE | ChargeIdStatusType.CHARGE_DONE

const statusDict: Record<StatusDictRecordKey, { label: string; icon: any; color: string }> = {
  [ChargeIdStatusType.WAITING_CHARGE]: {
    label: "Aguardando pagamento",
    icon: <BsClock />,
    color: "#6B7280",
  },
  [ChargeIdStatusType.CHARGE_DONE]: {
    label: "Pagamento confirmado",
    icon: <BsCheckCircleFill />,
    color: "#6B7280",
  },
};

const StatusPix = ({ status, handleConsultAgain }: { status: ChargeIdStatusType, handleConsultAgain: () => void }) => {
  return (
    <StatusList>
      {Object.keys(statusDict).filter(key => key === status).map((key) => {
        const { label, icon, color } = statusDict[key as StatusDictRecordKey];
        return (
          <StatusItem
            key={key}
            $active={key === status}
            $completed={key === status}
          >
            <StatusIcon $active={key === status} $completed={key === status}>
              {icon}
            </StatusIcon>
            <span style={{ color }}>{label}</span>
          </StatusItem>)
      })}
      {status === ChargeIdStatusType.EXPIRED && (
        <StatusItem
          $expired={status === ChargeIdStatusType.EXPIRED}
          style={{ alignItems: "start" }}
        >
          <StatusIcon $expired={status === ChargeIdStatusType.EXPIRED}>
            <CircleAlert style={{ fill: "#fd7e14", stroke: "#f7f7f7" }} />
          </StatusIcon>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.25rem",
            }}
          >
            <span style={{ color: "#6B7280", fontWeight: "600" }}>
              Pagamento expirado!
            </span>
            <ConsultLink onClick={handleConsultAgain}>
              Consultar novamente
            </ConsultLink>
          </div>
        </StatusItem>
      )}
    </StatusList>
  );
};

export default StatusPix;
